/**
 * Áudio não tem legenda no WhatsApp: o proto do `audioMessage` não tem o campo
 * `caption`. O modal de anexo mostrava a caixa de legenda para qualquer arquivo
 * e o texto era descartado na hora de montar o `POST /mensagens/enviar-audio` —
 * o operador digitava a legenda e ela nunca chegava a lugar nenhum.
 *
 * O predicado mora aqui para que a interface esconda a caixa exatamente para os
 * arquivos que o envio trata como áudio; se as duas regras divergirem, a caixa
 * volta a aparecer para um arquivo cuja legenda vai ser jogada fora.
 */

/**
 * Containers que o mime-db marca como vídeo (webm) ou genérico (ogg/ogx/opus)
 * mas que neste app são áudio.
 */
export const EXTENSOES_DE_AUDIO = ['opus', 'mp3', 'm4a', 'aac', 'wav', 'amr', 'flac', 'oga', 'ogg', 'ogx', 'weba', 'webm'];

/**
 * `mimeDeclarado` é o content-type REAL (override do chamador ou `File.type`),
 * nunca um palpite por extensão: a extensão só decide quando o type real não
 * afirma vídeo/imagem — assim um `.webm` de vídeo COM content-type continua
 * sendo vídeo.
 */
export function ehAnexoDeAudio(nomeArquivo: string, mimeDeclarado: string): boolean {
    const declarado = (mimeDeclarado || '').toLowerCase();
    if (declarado.includes('audio')) return true;

    const declaradoVisual = declarado.includes('video') || declarado.includes('image');
    const extensao = (nomeArquivo || '').split('?')[0].split('.').pop()?.toLowerCase() ?? '';
    return EXTENSOES_DE_AUDIO.includes(extensao) && !declaradoVisual;
}
